import map from 'lodash/map';

/**
 * @param data
 * @param finalMeters
 * @returns {*}
 */
export function materialCalculation(data, finalMeters) {
    if (null === data) {
        return [];
    }
    const productGroups = map(data.productGroups, (productGroup) => {
        let tempProducts = map(productGroup.products, (product) => {
            let tempProduct = {...product, consumption: 0};
            tempProduct.consumption = Math.ceil((finalMeters * product.quantity));
            return tempProduct;
        });

        productGroup.products = tempProducts;
        return productGroup;
    });
    return productGroups;
}



// WEBPACK FOOTER //
// ./src/components/calculation/helpers/calculator.js